var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95392 20.5865L7.67142 16.3135L3.38867 14.0213L4.81742 12.6077L8.35592 13.2135L11.1559 10.4135L3.44242 7.125L5.18667 5.35975L14.5617 6.99225L17.6714 3.873C18.0034 3.541 18.4127 3.375 18.8992 3.375C19.3857 3.375 19.795 3.541 20.1272 3.873C20.4592 4.20517 20.6252 4.61192 20.6252 5.09325C20.6252 5.57475 20.4592 5.9815 20.1272 6.3135L16.9924 9.4385L18.6252 18.798L16.8654 20.5578L13.5714 12.8442L10.7714 15.6442L11.3829 19.1578L9.95392 20.5865Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.f16df64ce497c256a087abda230caabe.svg";
export { ForwardRef as ReactComponent };